import { tv } from 'tailwind-variants';

export const buttonVariants = tv({
  base: [
    'inline-block',
    'font-medium',
    'transition-all',
    'duration-300',
    'cursor-pointer',
    'w-full',
    'min-w-40',
    'rounded-sm',
    'min-h-11',
    'px-5.5',
    'py-2.5',
    'text-lg',
    'leading-7.5',
    'text-center',
    // Disabled styles driven by the native :disabled / aria-disabled state so they apply even if the attribute is toggled in DevTools.
    'disabled:cursor-not-allowed',
    'disabled:opacity-50',
    'disabled:pointer-events-none',
    'aria-disabled:cursor-not-allowed',
    'aria-disabled:opacity-50',
    'aria-disabled:pointer-events-none',
  ],
  variants: {
    size: {
      fixed: ['w-full'],
      variable: ['w-fit'],
    },
    variant: {
      primary: ['bg-primary', 'text-white', 'hover:bg-tertiary'],
      'primary-outline': [
        'bg-white',
        'border',
        'border-primary',
        'text-primary',
        'hover:bg-primary',
        'hover:text-white',
      ],
      supporting: ['bg-tertiary', 'text-white', 'hover:bg-primary'],
      'supporting-outline': [
        'bg-white',
        'border',
        'border-tertiary',
        'text-tertiary',
        'hover:bg-tertiary',
        'hover:text-white',
      ],
      'light-blue': [
        'bg-accent-light-blue',
        'text-black',
        'hover:bg-hover-accent-light-blue',
        'hover:text-white',
      ],
      orange: [
        'bg-accent-orange',
        'text-black',
        'hover:bg-hover-accent-orange',
        'hover:text-white',
      ],
      green: ['bg-accent-green', 'text-black', 'hover:bg-hover-accent-green', 'hover:text-white'],
      'dark-green': ['bg-dark-green', 'text-white', 'hover:bg-hover-dark-green', 'hover:text-white'],
      yellow: [
        'bg-accent-yellow',
        'text-black',
        'hover:bg-hover-accent-yellow',
        'hover:text-white',
      ],
    },
  },
});
